<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">แพ็กเกจสมาชิก</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการแพ็กเกจสมาชิกออนไลน์ต่อลาน (GetMembershipPackages)
        <span class="text-amber-600 font-bold"> — ลาน: {{ selectedSiteName || 'กรุณาเลือกลาน' }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons text-xl">add_circle</span>
        เพิ่มแพ็กเกจ
      </button>
    </div>
  </div>

  <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">card_membership</span>
        รายการแพ็กเกจออนไลน์
      </h3>
      <div
        class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all w-full xl:w-min xl:min-w-[400px] h-[46px] overflow-hidden">
        <span class="material-icons ml-3 text-xl text-slate-400 dark:text-slate-500">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          (keyup.enter)="onSearch()" placeholder="ค้นหาชื่อ / ประเภทรถ..." [disabled]="!selectedSiteId"
          class="min-w-0 flex-1 h-full px-3 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600 disabled:cursor-not-allowed">
        <button type="button" (click)="onSearch()" [disabled]="!selectedSiteId"
          class="h-full px-5 text-sm font-bold text-white bg-amber-400 hover:bg-amber-500 transition-colors whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-50">
          ค้นหา
        </button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[280px]">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
          <tr>
            <th class="px-6 py-4">Subscription</th>
            <th class="px-6 py-4 text-center">แสดง</th>
            <th class="px-6 py-4">ชื่อแพ็กเกจ</th>
            <th class="px-6 py-4">ประเภทรถ</th>
            <!-- <th class="px-6 py-4 text-right">วัน</th> -->
            <th class="px-6 py-4 text-right">ราคา</th>
            <th class="px-6 py-4 text-center">VAT</th>
            <th class="px-6 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredItems()"
            class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
            <td class="px-6 py-4 text-slate-400 font-mono text-xs">{{ item.subscriptionId }}</td>
            <td class="px-6 py-4 text-center">
              <span class="material-icons text-[20px]" [ngClass]="item.isOnline ? 'text-emerald-600' : 'text-slate-400'"
                [title]="item.isOnline ? 'ออนไลน์' : 'ออฟไลน์'">
                {{ item.isOnline ? 'check_circle' : 'cancel' }}
              </span>
            </td>
            <td class="px-6 py-4 font-semibold text-slate-800 dark:text-slate-100">{{ item.name || '-' }}</td>
            <td class="px-6 py-4">{{ item.vehicleName || '-' }}</td>
            <!-- <td class="px-6 py-4 text-right font-mono">{{ item.figDay | number }}</td> -->
            <td class="px-6 py-4 text-right font-bold">{{ item.fee | number:'1.2-2' }}</td>
            <td class="px-6 py-4 text-center">
              <span class="text-xs font-bold" [ngClass]="item.vat ? 'text-emerald-600' : 'text-slate-400'">
                {{ item.vat ? (item.vatIncluded ? 'รวม VAT' : 'แยก VAT') : 'ไม่มี' }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)"
                class="p-2 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 text-amber-600"
                title="แก้ไข">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && filteredItems().length === 0">
            <td colspan="8" class="px-6 py-16 text-center text-slate-400">
              {{ selectedSiteId ? 'ไม่พบแพ็กเกจออนไลน์ของลานนี้' : 'กรุณาเลือกลานจาก Sidebar' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-4 border-t border-slate-100 dark:border-slate-700 text-xs text-slate-400">
      แสดง {{ filteredItems().length }} จาก {{ items().length }} รายการ
    </div>
  </div>
</div>

<app-modal-membership-package *ngIf="isModalOpen()"
  [editSubscriptionId]="editSubscriptionId()"
  [siteId]="selectedSiteId"
  [siteName]="selectedSiteName"
  (close)="closeModal()"
  (saveSuccess)="onSaved()">
</app-modal-membership-package>
